import { Env } from "./Env";

/**
 * The URL of a page of the documentation site at ``base``.
 *
 * @param base - Where the documentation lives, with or without a trailing slash.
 * @param path - The page's path on the docs site, such as ``"/learn/secrets"``
 *   or ``"/reference/cli/images#roboto-images-push"``. Empty for the docs home.
 * @returns The absolute URL of the page.
 */
export function docsUrlAt(base: string, path = ""): string {
  const trimmed = base.replace(/\/+$/, "");
  if (path === "" || path === "/") {
    return trimmed;
  }
  return path.startsWith("/") ? `${trimmed}${path}` : `${trimmed}/${path}`;
}

/**
 * The URL of a page of the public documentation, under ``Env.docsBaseUrl``.
 *
 * @param path - The page's path on the docs site. Empty for the docs home.
 *
 * @example
 * ```tsx
 * <a href={docsUrl("/learn/devices#registration")}>device registration</a>
 * ```
 */
export function docsUrl(path = ""): string {
  return docsUrlAt(Env.docsBaseUrl, path);
}
